<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">门店管理>新建加盟商</div>
		<div class="wais">
			<div class="wai">
				<div class="title">
					<div class="blue"></div>
					<div style="flex: 1;">加盟信息</div>
				</div>
				<div class="list">
					<div class="listcenter">
						<div>
							<span>加盟商名称</span>
							<el-input v-model="list.name" size="small" placeholder="请输入加盟商名称"></el-input>
						</div>
						<div>
							<span>授权人姓名</span>
							<el-input size="small" v-model="list.joinName" placeholder="请输入授权人姓名"></el-input>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<span>授权人联系方式</span>
							<el-input v-model="list.phone" size="small" placeholder="请输入授权人号码"></el-input>
						</div>
						<div>
							<span>授权人身份证号</span>
							<el-input v-model="list.idCard" size="small" placeholder="请输入授权人身份证号"></el-input>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<span>E-mali</span>
							<el-input v-model="list.email" size="small" placeholder="请输入邮箱"></el-input>
						</div>
						<div>
							<span>紧急联系人方式</span>
							<el-input v-model="list.sosPhone" size="small" placeholder="请输入紧急联系人号码"></el-input>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<span>授权人联系地址</span>
							<el-input size="small" v-model="list.address" placeholder="请输入授权人联系地址"></el-input>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<span>加盟商营业执照号码</span>
							<el-input size="small" v-model="list.businessNum" placeholder="请输入加盟商营业执照号码"></el-input>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<span>密码</span>
							<el-input size="small" v-model="list.password" placeholder="请输入登录密码"></el-input>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<div style="display: flex;">
								<upload id="upload" v-model="list.businessPhoto" style="width: 130px;height: 117px;">
								</upload>
								<div class="mberupload">
									<div style="margin-bottom: 15px;">营业执照上传</div>
									<el-button type="primary" size="small" @click="uploadclick">选择文件</el-button>
									<p>图片格式为：bmp，jpeg，jpg，gif，尺寸1:1，不可大于1M</p>
								</div>
							</div>
						</div>
					</div>
					<div class="title">
						<div class="blue"></div>
						<div style="flex: 1;">对接信息</div>
					</div>
					<div class="listcenter">
						<div>
							<span>招商对接人</span>
							<el-input v-model="list.dockingName" size="small" placeholder="请输入招商对接人姓名"></el-input>
						</div>
						<div>
							<span>招商对接联系方式</span>
							<el-input v-model="list.dockingPhone" size="small" placeholder="请输入招商对接人号码"></el-input>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<span>签约日期</span>
							<el-date-picker value-format="yyyy-mm-dd" style="width:310px;margin-left:-75px;"
								size="small" v-model="list.signUp" type="date" placeholder="请选择时间">
							</el-date-picker>
						</div>
						<div>
							<span>合同期限</span>
							<el-date-picker value-format="yyyy-mm-dd" size="small"
								style="width:310px;margin-left:-75px;" v-model="list.contract" type="daterange"
								start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<span>运营对接人</span>
							<el-input v-model="list.operateName" size="small" placeholder="请输入运营对接人姓名"></el-input>
						</div>
						<div>
							<span>运营对接联系方式</span>
							<el-input v-model="list.operatePhone" size="small" placeholder="请输入运营对接人号码"></el-input>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<div style="display: flex;">
								<upload id="upload" v-model="list.joinPhoto" style="width: 130px;height: 117px;">
								</upload>
								<div class="mberupload">
									<div style="margin-bottom: 15px;">加盟合同上传</div>
									<el-button type="primary" size="small" @click="uploadclick">选择文件</el-button>
									<p>图片格式为：bmp，jpeg，jpg，gif，尺寸1:1，不可大于1M</p>
								</div>
							</div>
						</div>
					</div>
					<div class="title">
						<div class="blue"></div>
						<div style="flex: 1;">加盟商资金状况</div>
					</div>
					<div class="listcenter2">
						<div class="jiaomoney" style="margin-bottom:10px">
							<span>门店配置(可选)</span>
							<el-checkbox-group v-model="list.store" style="margin-left: 20px; width:100%">
								<span v-for="i in storeList" :key="i.id" style="display: flex;margin-left: 10px;">
									<div style="width: 100%;">
										<el-checkbox :label="i.id+''"
											@change="i.franchiseesId ==list.id?delFranchiseesStore(i.id,i.franchiseesId):''"
											style="width: 10%;">{{i.title}} </el-checkbox>
										<span
											v-if="i.franchiseesId!=null && i.franchiseesId ==list.id || i.id==list.store[list.store.length-1]">
											<span>
												加盟状态
												<el-select size="small" v-model="i.franchiseesStatus"
													placeholder="加盟状态">
													<el-option v-for="item in franchiseesStatus" :key="item.value"
														:label="item.label" :value="item.value">
													</el-option>
												</el-select>
											</span>
											<span>
												<span>合同期限</span>
												<el-date-picker v-model="i.franchiseesTime" type="daterange"
													size="small" style="width: 15%;" value-format="yyyy-MM-dd"
													range-separator="至" start-placeholder="合同开始" end-placeholder="合同结束">
												</el-date-picker>
												<el-input style="width: 15%;" v-model="i.franchiseesStorePhone"
													size="small" placeholder="门店端管理员电话"></el-input>
												开店时间
												<el-date-picker value-format="yyyy-MM-dd" size="small"
													v-model="i.franchiseesOpenTime"
													style="width: 15%;position: relative;z-index: 100;" type="date"
													placeholder="开店日期">
												</el-date-picker>
												<el-input style="width: 15%;" v-model="i.franchiseesStoreName"
													size="small" placeholder="门店管理员信息"></el-input>
												<el-input style="width: 10%;" v-model="i.franchiseesStorePassword"
													size="small" placeholder="门店登陆密码"></el-input>
											</span>
											<el-button type="primary" size="small" @click="editStore(i)">确认</el-button>
										</span>
									</div>
								</span>
							</el-checkbox-group>
						</div>
						<div class="jiaomoney">
							<div style="width:120px;">是否缴纳备用金</div>
							<div class="jiaom1">
								<div>
									<el-radio v-model="list.isPayment" label="1">已缴纳</el-radio>
								</div>
								<div>
									<el-input v-model="list.paymentNum" min="0" v-if="list.isPayment==1"
										style="width: 300px;margin-top: 10px;" type="number" size="small"
										placeholder="请输入缴纳金额/单位(元)"></el-input>
								</div>
							</div>
						</div>
						<div class="jiaomoney" style="margin-top: 20px;">
							<div style="width:120px;"></div>
							<div class="jiaom1">
								<div>
									<el-radio v-model="list.isPayment" label="2">否</el-radio>
								</div>
								<div v-if="list.isPayment==2">
									<span>设置通知时限</span>
									<el-date-picker size="small" style="width:260px;margin-left:20px;"
										v-model="list.noticeTime" type="datetime" value-format="yyyy-mm-dd HH:mm:ss"
										placeholder="请选择开店时间">
									</el-date-picker>
									<!-- <el-date-picker
												value-format="yyyy-MM-DD HH:mm:ss"
												type="datetime"
												size="small"
												v-model="list.noticeTime"
												placeholder="请选择开店时间"></el-date-picker> -->
								</div>
								<span v-if="list.isPayment==2"
									style="font-size: 12px;color:#AAAAB1;">通知时限会通知至运营主管、财务主管、招商主管</span>
							</div>
						</div>
					</div>
					<div class="listcenter">
						<div>
							<span>加盟备注</span>
							<el-input type="textarea" placeholder="请输入加盟备注" v-model="list.joinComment" maxlength="500"
								show-word-limit style="width: 600px;margin-left: -100px;" rows="10"></el-input>
						</div>
					</div>
				</div>
				<div class="button_s">
					<el-button size="small" @click="goback">返回</el-button>
					<!-- <el-button type="primary" size="small" @click="getnext">下一步</el-button> -->
					<el-button type="primary" size="small" @click="edit">保存</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import upload from "../compents/upload/upload.vue"
	export default {
		components: {
			upload
		},
		data() {
			return {
				ischange: false,
				list: {
					address: "", //授权人联系地址
					sosPhone: "", //经济联系人电话
					email: "", //电子邮箱
					name: "", //加盟商名称
					joinName: "", //授权人姓名
					phone: "", //授权人联系方式
					password: "",
					dockingPhone: "", //招商对接人联系方式
					idCard: "", //授权人身份证号码
					businessNum: "", //营业执照号码
					businessPhoto: "", //营业执照图片
					signUp: "", //签约日期
					contract: [],
					dockingName: "", //运营对接人名字
					operatePhone: "", //运营对接人电话
					joinPhoto: "", //加盟合同
					isPayment: "", //是否缴纳保证金
					paymentNum: "", //缴纳金额
					joinComment: "", //加盟备注
					contractStart: "", //合同开始时间
					contractEnd: "", //合同结束时间
					noticeTime: "", //保证金通知时间
					store: [],
				},
				storeList: [],
				franchiseesStatus: [{
					label: "选址中",
					value: 0,
				}, {
					label: "装修中ID",
					value: 1,
				}, {
					label: "物资配送中",
					value: 2,
				}, {
					label: "确定营业中",
					value: 3,
				}, {
					label: "营业中",
					value: 4
				}, {
					label: "合约已到期",
					value: 5,
				}, ],
			}
		},
		mounted() {
			console.log(this.$route.query.demo)
			console.log(this.$route.query.id)
			// if(this.$route.query.demo==1){
			// 	this.ischange=this.$route.query.demo
			// 	this.list= JSON.parse(localStorage.getItem('addfriends'));
			// 	if(this.list.noticeTime){
			// 		this.list.noticeTime= new Date(Date.parse(this.list.noticeTime.replace(/-/g,   "/"))); //转换成Data();
			// 		this.list.noticeTime=this.dateFormat(this.list.noticeTime)
			// 	}
			// }
			if (this.$route.query.demo == 2 || this.$route.query.demo == 3) {
				this.ischange = this.$route.query.demo
				this.$http.get("store/getFranchisees?id=" + this.$route.query.id).then(function(res) {
					if (res.body.code == "200") {
						this.list = res.body.data
						this.getstorelist(this.list.id);
						this.list.isPayment = this.list.isPayment + ""
						this.list.store = this.list.store.split(',');
						if (this.list.contractStart) {
							var a = []
							a[0] = this.list.contractStart
							a[1] = this.list.contractEnd
							this.list.contract = a
						}
					}
				})
			} else if (!this.$route.query.demo) {
				this.getstorelist();
			}
		},
		methods: {
			// 获取门店列表
			getstorelist(id) {
				console.log("11")
				this.$http.get("store/noFranchisees?id=" + id).then(res => {
					var a = res.body.data;
					for (var i = 0; i < a.length; i++) {
						if (a[i].franchiseesStartTime) {
							a[i].franchiseesTime = [a[i].franchiseesStartTime, a[i].franchiseesEndTime]
						}
					}
					this.storeList = a
				})
			},
			goback() {
				// this.$router.push({ path: 'storeList', query: { id: 2 } })
				this.$router.push({
					path: 'join'
				})
			},
			// 转换时间
			dateFormat: function(time) {
				var date = new Date(time);
				var year = date.getFullYear();
				/* 在日期格式中，月份是从0开始的，因此要加0
				 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
				 * */
				var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
				var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
				var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
				var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
				var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
				// 拼接
				return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
			},
			edit() {
				// if(
				// this.list.name==""||this.list.joinName==""||
				// 	this.list.businessNum==""||this.list.businessPhoto==""||this.list.signUp==null||this.list.contract==null||
				// 	this.list.dockingName==""||this.list.joinPhoto==""||this.list.isPayment==""
				// 	){
				// 	return this.$message.error("请填写完成后再提交！");
				// }else{
				// 	this.list.contractStart = this.list.contract[0]
				// 	this.list.contractEnd = this.list.contract[1]
				// 	if(!(/^1[3456789]\d{9}$/.test(this.list.phone))) return this.$message.error("授权人联系方式号码有误!");
				// 	if(!(/^1[3456789]\d{9}$/.test(this.list.sosPhone))) return this.$message.error("紧急联系人号码有误!");
				// 	if(!(/^1[3456789]\d{9}$/.test(this.list.dockingPhone))) return this.$message.error("招商对接人号码有误!");
				// 	if(!(/^1[3456789]\d{9}$/.test(this.list.operatePhone))) return this.$message.error("运营对接人号码有误!");
				if (this.list.isPayment == 1) {
					this.list.noticeTime = ""
					if (this.list.paymentNum == "") return this.$message.error("请填写完成后再提交")
				}
				if (this.list.isPayment == 2) {
					this.list.paymentNum = ""
					if (this.list.noticeTime == "") return this.$message.error("请填写完成后再提交");
				}
				var temp = JSON.parse(JSON.stringify(this.list));
				temp.contract = undefined;
				temp.store = temp.store.toString();
				this.$http.post("store/editFranchisees", JSON.stringify(temp)).then(function(res) {
					if (res.body.code == "200") {
						this.$message.success("保存成功");
						this.goback()
					}
				})
				// }
			},
			editStore(i) {
				if (i.franchiseesStatus == null || i.franchiseesTime[0] == null || i.franchiseesTime[1] == null || i
					.franchiseesStorePhone == null || i.franchiseesOpenTime == null) {
					return this.$message.error("门店信息不能为空！");
				} else {
					if (this.list.store[0] == "") {
						this.list.store = this.list.store[1]
					}
					var temp = JSON.parse(JSON.stringify(this.list));
					temp.contract = undefined;
					temp.store = temp.store.toString();
					this.$http.post("store/editFranchisees", JSON.stringify(temp)).then(function(res) {
						if (res.body.code == "200") {
							var a = {}
							a.id = i.id
							a.franchiseesStatus = i.franchiseesStatus
							a.franchiseesStartTime = i.franchiseesTime[0]
							a.franchiseesEndTime = i.franchiseesTime[1]
							a.franchiseesStorePhone = i.franchiseesStorePhone
							a.franchiseesOpenTime = i.franchiseesOpenTime
							a.franchiseesStoreName = i.franchiseesStoreName
							a.franchiseesStorePassword = i.franchiseesStorePassword
							console.log(a)
							this.$http.post("store/editFranchiseesStore", JSON.stringify(a)).then(function(res) {
								if (res.body.code == "200") {
									this.$message.success("保存成功");
									// this.getstorelist(this.list.id);
									window.location.reload()
								}
							})
						}
					})
				}
			},
			delFranchiseesStore(id, franchiseesId) {
				if (franchiseesId != null && franchiseesId != undefined) {
					window.location.reload()
				}
				this.$http.post("store/delFranchiseesStore?id=" + id + "&franchiseesId=" + franchiseesId +
					"&franchiseesName=" + this.list.name).then(function(res) {
					if (res.body.code == "200") {
						this.$message.success("保存成功");
					}
				})
			},
			getnext() {
				if (this.list.address == "" || this.list.email == "" || this.list.name == "" || this.list.joinName == "" ||
					this.list.idCard == "" ||
					this.list.businessNum == "" || this.list.businessPhoto == "" || this.list.signUp == null || this.list
					.contract == null ||
					this.list.dockingName == "" || this.list.joinPhoto == "" || this.list.isPayment == "") {
					return this.$message.error("请填写完成后再提交！");
				} else {
					this.list.contractStart = this.list.contract[0]
					this.list.contractEnd = this.list.contract[1]
					if (!(/^1[3456789]\d{9}$/.test(this.list.phone))) return this.$message.error("授权人联系方式号码有误!");
					if (!(/^1[3456789]\d{9}$/.test(this.list.sosPhone))) return this.$message.error("紧急联系人号码有误!");
					if (!(/^1[3456789]\d{9}$/.test(this.list.dockingPhone))) return this.$message.error("招商对接人号码有误!");
					if (!(/^1[3456789]\d{9}$/.test(this.list.operatePhone))) return this.$message.error("运营对接人号码有误!");
					if (this.list.isPayment == 1) {
						this.list.noticeTime = ""
						if (this.list.paymentNum == "") return this.$message.error("请填写完成后再提交")
					}
					if (this.list.isPayment == 2) {
						this.list.paymentNum = ""
						if (this.list.noticeTime == "") return this.$message.error("请填写完成后再提交");
					}
					localStorage.setItem('addfriends', JSON.stringify(this.list))
					this.$router.push({
						path: "/newJoinnext"
					})
				}
			},
			uploadclick() {
				document.querySelector(".el-upload--picture-card").click()
				document.getElementById("upload").click();
			}
		}
	};
</script>
<style lang="less" scoped>
	.listcenter2 {
		box-sizing: border-box;
		padding-left: 20px;

		.jiaomoney {
			display: flex;

			.jiaom1 {
				margin-left: 20px;
			}
		}
	}

	.list {
		.listcenter {
			&:nth-child(n+2) {
				margin-top: 20px;
			}

			display: flex;

			>div {
				span {
					margin-left: 25px;
					width: 220px;
					line-height: 32px;
				}

				display: flex;
				flex: 1;
			}
		}
	}

	.wailianjie {
		display: flex;

		/deep/ .wailj_title {
			width: 100px;
		}
	}

	.dialog-footer {
		margin-right: 32%;
	}

	.button_s {
		margin-top: 20px;
		margin-left: 30%;
		margin-bottom: 50px;
	}

	.list1 {
		>div {
			padding-left: 50px;

			p {
				width: 233px;
				height: 47px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #C8C8C8;
				line-height: 2.1;
			}
		}
	}

	.mioasu {
		margin-left: 60px;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3D3D3D;
		opacity: 0.38;
	}

	// 标题
	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.wais {
		display: flex;
	}

	.wai2 {
		.demo2 {
			margin-top: 50px;
			position: relative;
			left: 50%;
			margin-left: -175px;
			width: 300px;
			height: 600px;
			border-radius: 7px;
			overflow: hidden;
			margin: auto;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.adds {
		width: 145px;
		height: 34px;
		text-align: center;
		line-height: 34px;
		border: 1px dashed #9D9D9D;
		color: #9D9D9D;
		cursor: pointer;
	}

	.addlist {
		display: inline-block;
		margin-top: 10px;
		padding-left: 10px;
		padding-right: 10px;
		position: relative;
		text-align: center;
		border-radius: 5px;
		border: 1px solid black;
		transition: 0.3s;

		&:hover {
			div {
				display: block;
			}
		}

		div {
			display: none;
			cursor: pointer;
			position: absolute;
			top: -8px;
			right: -8px;
			background-color: red;
			color: white;
			border-radius: 50%;
			width: 20px;
			height: 20px;
			text-align: center;
			line-height: 20px;
			font-size: 16px;
		}
	}

	.mberupload {
		margin-left: 40px;

		p {
			width: 300px;
			font-size: 14px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #C8C8C8;
			line-height: 1.6;
		}
	}
</style>